import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    addSubscriptionFormAction,
    oneTimeWorkoutFormAction,
    setBookingUsersFormAction,
    userFormAction
} from "../../redux/rootReducer";
import {
    addUserToBookingSagaAction,
    getAvailableSubscriptionsSagaAction,
    removeMissedWorkoutSagaAction,
    removeUserFromBookingSagaAction,
    getUsersForSubscriptionSagaAction,
    getWeekBookingSagaAction
} from "../../redux/sagaActions";
import {
    ADD_SUBSCRIPTION_FORM_INITIAL,
    BOOKING_USERS_FORM_INITIAL,
    ONE_TIME_WORKOUT_FORM_INITIAL,
    USER_FORM_INITIAL
} from "../../redux/initialStateConstant";
import Tippy from "@tippyjs/react";

const BookingUsersForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const booking_users_form = useSelector(state => state.booking_users_form);
    const weekBooking = useSelector(state => state.weekBooking);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    // Начальный список пользователей при открытии окна
    const initialUsersList = useRef([]);
    // Список записанных пользователей
    const usersList = useRef([]);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(setBookingUsersFormAction({
                ...booking_users_form,
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'booking_users_form', 'children': '1' }));
        }, 500);
    };

    // Обработчик клика на фамилии пользователя
    const UserClickHandler = ({ event, user }) => {
        if (event.button === 1) {
            event.preventDefault();

            window.open(
                'https://alga.by/fitness/users/' + user,
                '_blank',
                'noopener,noreferrer'
            );
        }
    };

    useEffect(() => {
        // Собираем в массив id пользователей
        usersList.current = booking_users_form.checkedUsers.map(el => el.id).sort();

    }, [booking_users_form.checkedUsers]);

    // Проверяем изменения в списке пользователей
    useEffect(() => {
        // Собираем в массив id пользователей при открытии окна
        initialUsersList.current = booking_users_form.checkedUsers.map(el => el.id).sort();

        return () => {
            // Обновляем расписание, при изменении списка пользователей
            if (JSON.stringify(initialUsersList.current) !== JSON.stringify(usersList.current)) {
                dispatch(getWeekBookingSagaAction({
                    establishment: currentEstablishment,
                    date: weekBooking.date
                }));
            }
        };
    }, []);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content" style={{ minHeight: '388px' }}>
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => dispatch(setBookingUsersFormAction(BOOKING_USERS_FORM_INITIAL)) }
                        />
                        <div className="form__title">
                            Список посетителей
                        </div>
                    </div>
                    <div className="form__subtitle-wrapper">
                        <div className="form__subtitle" style={{ fontWeight: 600 }}>{ booking_users_form.type.name }</div>
                        <div className="form__subtitle" style={{ fontSize: 12 }}>{ booking_users_form.datetime }</div>
                    </div>
                    <>
                        <div className="form__field">
                            <div className="input__caption">Посетитель (почта или телефон)</div>
                            <div className="dropdown">
                                <input type="text" className="input"
                                       value={ booking_users_form.userInput || '' }
                                       onInput={ event => {
                                           dispatch(setBookingUsersFormAction({
                                               ...booking_users_form,
                                               userInput: event.target.value
                                           }));
                                           // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                           getUsers(event.target.value);
                                       } }
                                       disabled={ booking_users_form.canceled }
                                />
                                <div className={ `dropdown__items ${ booking_users_form.userInput ? 'dropdown__items--open' : false }` }>
                                    {
                                        booking_users_form.users?.length
                                            ? booking_users_form?.users?.map(elem => {
                                                return (
                                                    <div className="dropdown__item" key={ elem.id }
                                                         onClick={ () => {
                                                             // Если записываем ребёнка
                                                             if (elem.child_id) {
                                                                 dispatch(addUserToBookingSagaAction({
                                                                     booking_id: booking_users_form.id,
                                                                     user_id: elem.parent_id,
                                                                     child_id: elem.child_id
                                                                 }));
                                                             }
                                                             else {
                                                                 // Добавляем нового пользователя
                                                                 dispatch(addUserToBookingSagaAction({
                                                                     booking_id: booking_users_form.id,
                                                                     user_id: elem.id
                                                                 }));
                                                             }
                                                         } }
                                                    >{ `${ elem.name } ${ elem.phone }` }</div>
                                                );
                                            })
                                            : <div className="dropdown__item"
                                                   onClick={ () => {
                                                       // Переходим на страницу с посетителями
                                                       history.push('/fitness/users');
                                                       // Закрываем форму добавления абонемента
                                                       dispatch(setBookingUsersFormAction({
                                                           ...booking_users_form,
                                                           open: false
                                                       }));
                                                       // Открываем форму добавления посетителя
                                                       dispatch(userFormAction({
                                                           ...USER_FORM_INITIAL,
                                                           open: true,
                                                           title: 'Новый посетитель'
                                                       }));
                                                   } }
                                            >{ `Добавить посетителя` }</div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="form__field">
                            {
                                booking_users_form.checkedUsers.length > 0 &&
                                <div className="input__caption">Посетители</div>
                            }
                            {
                                booking_users_form.checkedUsers.map((user, index) => {
                                    return (
                                        <div className="booking__user" key={ user.id + '|' + index }>
                                            <div className="booking__user-number">{ index + 1 }</div>
                                            <div className="booking__user-info">
                                                { user.count_workouts !== null && <div className="booking__user-new">Новый посетитель!</div> }
                                                <div className="booking__user-wrap">
                                                    { user.debt_sum && <Tippy content={ user.debt_sum }><div className="booking__user-debt-sum"/></Tippy> }
                                                    { user.user_note && <Tippy content={ user.user_note } ><div className="booking__user-note"/></Tippy> }
                                                    <div className={ `booking__user-name ${ user.queue ? 'booking__user-name--queue' : '' }`}
                                                         onClick={ () => {
                                                             // Закрываем карточку клиента
                                                             dispatch(setBookingUsersFormAction(BOOKING_USERS_FORM_INITIAL));
                                                             // Переходим в карточку клиента
                                                             history.push('/fitness/users/' + user.id);
                                                         } }
                                                         onMouseDown={ event => UserClickHandler({ event, user: user.id }) }
                                                    >{ user.name }</div>
                                                </div>
                                                <div className="booking__user-phone">{ user.phone }</div>
                                                { user.debt_workout && <div className="booking__user-debt">Тренировка в долг!</div> }
                                                {
                                                    user.subscription_note
                                                        ?
                                                        <Tippy content={ `${ user.subscription_note }` }>
                                                            <div className="info"/>
                                                        </Tippy>
                                                        : false
                                                }
                                                {
                                                    user.subscription &&
                                                    <div className="booking__user-subscription">{ user.subscription }</div>
                                                }
                                            </div>
                                            <div className="booking__user-buttons">
                                                <div className="booking__user-buttons-row">
                                                    {
                                                        user.absented === '1' &&
                                                        <Tippy content={ 'Отметить присутствие' }>
                                                            <div className="booking__user-button booking__user-button--missed-workout"
                                                                 onClick={ () => {
                                                                     if (!window.confirm('Подтвердить посещение?')) return;

                                                                     dispatch(removeMissedWorkoutSagaAction({
                                                                         id: user.b_u_id,
                                                                         type: 'booking',
                                                                         booking_id: booking_users_form.id
                                                                     }));
                                                                 } }
                                                            />
                                                        </Tippy>
                                                    }
                                                    <Tippy content={ user.check_workout ? 'Тренировка списана' : 'Списать тренировку' }>
                                                        <div className={ `booking__user-button booking__user-button--check-workout ${ user.check_workout && 'booking__user-button--check-workout-checked' }` }
                                                             onClick={ () => {
                                                                 // Выходим из функции, если тренировка уже списана
                                                                 if (user.check_workout) return;

                                                                 dispatch(getAvailableSubscriptionsSagaAction({
                                                                     user: user.id,
                                                                     child_id: user.child_id,
                                                                     booking_id: booking_users_form.id
                                                                 }));
                                                             } }
                                                        />
                                                    </Tippy>
                                                    <div className="booking__user-button booking__user-button--remove"
                                                         onClick={ () => {
                                                             // Подтверждение удаления пользователя
                                                             if (window.confirm('Вы действительно хотите удалить посетителя?')) {
                                                                 // Удаление пользователя из записи
                                                                 dispatch(removeUserFromBookingSagaAction({
                                                                     booking_id: booking_users_form.id,
                                                                     user_id: user.id,
                                                                     child_id: user.child_id,
                                                                     booking_users_id: user.b_u_id
                                                                 }));
                                                             }
                                                         } }
                                                    />
                                                </div>
                                                <div className="booking__user-buttons-row">
                                                    <Tippy content={ `Добавить абонемент` }>
                                                        <div className="booking__user-button booking__user-button--subscription"
                                                             onClick={ () => {
                                                                 dispatch(addSubscriptionFormAction({
                                                                     ...ADD_SUBSCRIPTION_FORM_INITIAL,
                                                                     open: true,
                                                                     user: { id: user.id, name: user.name, sum: '', subscriptions: '', deposits: '' },
                                                                     addition_date: new Date().toLocaleDateString('fr-CA')
                                                                 }));
                                                             } }
                                                        />
                                                    </Tippy>
                                                    <Tippy content={ `Разовая тренировка` }>
                                                        <div className="booking__user-button booking__user-button--workout"
                                                             onClick={ () => {
                                                                 dispatch(oneTimeWorkoutFormAction({
                                                                     ...ONE_TIME_WORKOUT_FORM_INITIAL,
                                                                     open: true,
                                                                     user: { id: user.id, name: user.name, sum: '', subscriptions: '', deposits: '' },
                                                                     type: booking_users_form.type,
                                                                     coach: booking_users_form.coach,
                                                                     date: booking_users_form.date,
                                                                     time: booking_users_form.time
                                                                 }));
                                                             } }
                                                        />
                                                    </Tippy>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
};

export default BookingUsersForm;